import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {NbDialogRef} from '@nebular/theme';

@Component({
  template: `<nb-card accent="primary" style="width: 350px; padding: 8px;">
    <h1 style="border-bottom: 1px solid #000;margin-top:0 !important;">תודה!</h1>
    <p>שמחנו שהרכב עניין אותך</p>
    <button nbButton status="success" (click)="close()">back</button>
  </nb-card>
  `,
})
export class ThankYouGaDialogComponent {
  constructor(public dialogRef: NbDialogRef<ThankYouGaDialogComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
